import { trigger, animate, transition, style, query, stagger } from '@angular/animations';

export function slideInUpStagger(className, degree, opacity, status) {
  return trigger('slideInUpStagger', [
    transition(`* => ${status}`, [
      query(
        `.${className}`,
        style({
          opacity: 0,
          transform: `translate3d(0, ${degree}, 0)`
        })
      ),
      query(
        `.${className}`,
        stagger('50ms', [
          animate('400ms ease-out',
            style({
              opacity: opacity,
              transform: 'none'
            }))
        ])
      )
    ])
  ]);
}



// WEBPACK FOOTER //
// ./src/app/shared/animations/slide-in-up-stagger.animation.ts